// Mesquite Mafia: Kinematics & Recoil FX
import { playSFX, SFX } from './audio.js';

export function spawnBulletHole() {
      const hole = document.createElement('div');
      hole.className = 'bullet-hole';
      hole.style.left = (window.innerWidth / 2 + (Math.random() * 320 - 160)) + 'px';
      hole.style.top = (window.innerHeight / 2 + (Math.random() * 240 - 120)) + 'px';
      document.body.appendChild(hole);
      setTimeout(() => hole.remove(), 2200);
    }

export function triggerGunAnimation(shots = 3, callback) {
      const overlay = document.getElementById('action-stage-overlay');
      const weapon = document.getElementById('action-weapon-icon');
      const flash = document.getElementById('muzzle-flash');
      
      overlay.style.display = 'flex';
      
      let count = 0;
      if (shots <= 0) {
        setTimeout(() => {
          overlay.style.display = 'none';
          if (callback) callback();
        }, 1100);
        return;
      }

      const fireInterval = setInterval(() => {
        if (count >= shots) {
          clearInterval(fireInterval);
          setTimeout(() => {
            overlay.style.display = 'none';
            if (callback) callback();
          }, 600);
          return;
        }

        weapon.classList.remove('gun-recoil');
        flash.classList.remove('muzzle-active');
        void weapon.offsetWidth;
        void flash.offsetWidth;

        weapon.classList.add('gun-recoil');
        flash.classList.add('muzzle-active');
        
        SFX.gunshot();
        document.body.classList.add('screen-shake');
        setTimeout(() => document.body.classList.remove('screen-shake'), 300);

        spawnBulletHole();
        count++;
      }, 230);
    }

export function playActionSequence({ title, icon, detail, rewardText, shots = 3, onComplete }) {
      document.getElementById('action-banner-title').innerText = title;
      document.getElementById('action-weapon-icon').innerText = icon || '🔫';
      document.getElementById('action-banner-detail').innerText = detail;
      document.getElementById('action-banner-reward').innerText = rewardText || '';
      
      triggerGunAnimation(shots, () => {
        if (onComplete) onComplete();
      });
    }

export function initPointerKinematics() {
      let mouseX = -999;
      let mouseY = -999;
      let ticking = false;

      window.addEventListener('pointermove', (e) => {
        mouseX = e.clientX;
        mouseY = e.clientY;

        if (!ticking) {
          requestAnimationFrame(() => {
            document.documentElement.style.setProperty('--mouse-x', `${mouseX}px`);
            document.documentElement.style.setProperty('--mouse-y', `${mouseY}px`);

            document.querySelectorAll('.volumetric-hover:hover').forEach(card => {
              const rect = card.getBoundingClientRect();
              card.style.setProperty('--mouse-x', `${mouseX - rect.left}px`);
              card.style.setProperty('--mouse-y', `${mouseY - rect.top}px`);
            });
            ticking = false;
          });
          ticking = true;
        }
      }, { passive: true });

      initTiltCards();
      initSurveillanceClock();
    }

export function initTiltCards() {
  const cardSelector = '.tactical-tilt-card, .tilt-card, .item-card, .archetype-card, .avatar-choice-card, .compound-station-card, .store-pack, .hud-card, .infographic-card, .tactical-choice-btn, .duo-character-card, .mission-card-item, .start-duo-badge';

  let activeCard = null;
  let animFrame = null;

  document.addEventListener('pointermove', (e) => {
    const card = e.target.closest(cardSelector);
    if (!card) {
      if (activeCard) {
        activeCard.style.transform = 'perspective(900px) rotateX(0deg) rotateY(0deg) translateY(0px) scale3d(1, 1, 1)';
        activeCard = null;
      }
      return;
    }

    activeCard = card;
    const rect = card.getBoundingClientRect();
    const x = e.clientX - rect.left;
    const y = e.clientY - rect.top;
    const centerX = rect.width / 2;
    const centerY = rect.height / 2;

    const rotateX = -((y - centerY) / centerY) * 8.5;
    const rotateY = ((x - centerX) / centerX) * 8.5;

    const glintX = Math.max(0, Math.min(100, (x / rect.width) * 100)).toFixed(1);
    const glintY = Math.max(0, Math.min(100, (y / rect.height) * 100)).toFixed(1);

    if (animFrame) cancelAnimationFrame(animFrame);
    animFrame = requestAnimationFrame(() => {
      card.style.setProperty('--tilt-glint-x', `${glintX}%`);
      card.style.setProperty('--tilt-glint-y', `${glintY}%`);
      card.style.transform = `perspective(900px) rotateX(${rotateX.toFixed(2)}deg) rotateY(${rotateY.toFixed(2)}deg) translateY(-5px) scale3d(1.02, 1.02, 1.02)`;
    });
  }, { passive: true });

  document.addEventListener('pointerout', (e) => {
    const card = e.target.closest(cardSelector);
    if (card && !card.contains(e.relatedTarget)) {
      card.style.transform = 'perspective(900px) rotateX(0deg) rotateY(0deg) translateY(0px) scale3d(1, 1, 1)';
      if (activeCard === card) activeCard = null;
    }
  }, { passive: true });
}

export function initSurveillanceClock() {
  const clockEl = document.getElementById('live-hud-clock');
  if (!clockEl) return;
  function tick() {
    const now = new Date();
    const h = String(now.getHours()).padStart(2, '0');
    const m = String(now.getMinutes()).padStart(2, '0');
    const s = String(now.getSeconds()).padStart(2, '0');
    clockEl.innerText = `${h}:${m}:${s} CST`;
  }
  tick();
  setInterval(tick, 1000);
}

